module.exports = __webpack_public_path__ + "static/media/avc_breath.25077f8b.svg";